import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';

// テンプレート機能にwidgetをセットする
export default class SimpleBoxEditing extends Plugin {
  static get requires() {
    return [Widget];
  }

  init() {
    const editor = this.editor;
    const t = editor.t;

    this._defineSchema();
    this._defineConverters();
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    // // --- aaa ここから ---------
    // schema.register( 'aaa', {
    //     // Behaves like a self-contained object (e.g. an image).
    //     isObject: true,

    //     // Allow in places where other blocks are allowed (e.g. directly in the root).
    //     allowWhere: '$block'
    // } );

    // schema.register( 'bbb', {
    //     // Cannot be split or left by the caret.
    //     isLimit: true,

    //     allowIn: 'aaa',

    //     // Allow content which is allowed in blocks (i.e. text with attributes).
    //     allowContentOf: '$block',
    //     // allowContentOf: '$root',
    //     // allowAttributes: [ 'class', 'htmlDivAttributes' ],
    //     allowAttributes: [ 'class', 'id', 'section_id' ],

    // } );
    // // --- aaa ここまで ---------

    // --- イラスト有り危険 ここから ---------
    schema.register('illustratedDanger', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('illustratedDangerTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'illustratedDanger',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      // allowContentOf: '$block'
      allowContentOf: '$root',
    });

    schema.register('illustratedDangerDescription', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'illustratedDanger',

      // Allow content which is allowed in the root (e.g. paragraphs).
      allowContentOf: '$root',
    });

    schema.addChildCheck((context, childDefinition) => {
      if (context.endsWith('illustratedDangerDescription') && childDefinition.name == 'illustratedDanger') {
        return false;
      }
    });
    // --- イラスト有り危険 ここまで ---------

    // --- イラスト有り警告 ここから ---------
    schema.register('illustratedWarning', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('illustratedWarningTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'illustratedWarning',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      // allowContentOf: '$block'
      allowContentOf: '$root',
    });

    schema.register('illustratedWarningDescription', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'illustratedWarning',

      // Allow content which is allowed in the root (e.g. paragraphs).
      allowContentOf: '$root',
    });

    schema.addChildCheck((context, childDefinition) => {
      if (context.endsWith('illustratedWarningDescription') && childDefinition.name == 'illustratedWarning') {
        return false;
      }
    });
    // --- イラスト有り警告 ここまで ---------

    // --- イラスト有り注意 ここから ---------
    schema.register('illustratedCaution', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('illustratedCautionTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'illustratedCaution',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      // allowContentOf: '$block'
      allowContentOf: '$root',
    });

    schema.register('illustratedCautionDescription', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'illustratedCaution',

      // Allow content which is allowed in the root (e.g. paragraphs).
      allowContentOf: '$root',
    });

    schema.addChildCheck((context, childDefinition) => {
      if (context.endsWith('illustratedCautionDescription') && childDefinition.name == 'illustratedCaution') {
        return false;
      }
    });
    // --- イラスト有り注意 ここまで ---------

    // --- イラスト有り本文 ここから ---------
    schema.register('illustedText', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('illustedTextTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'illustedText',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      // allowContentOf: '$block'
      allowContentOf: '$root',
    });

    schema.register('illustedTextDescription', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'illustedText',

      // Allow content which is allowed in the root (e.g. paragraphs).
      allowContentOf: '$root',
    });

    schema.addChildCheck((context, childDefinition) => {
      if (context.endsWith('illustedTextDescription') && childDefinition.name == 'illustedText') {
        return false;
      }
    });
    // --- イラスト有り本文 ここまで ---------

    // --- 警告 ここから ---------
    schema.register('warning', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('warningTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'warning',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      // allowContentOf: '$block'
      allowContentOf: '$root',
    });

    // --- 警告 ここまで ---------

    // --- 危険 ここから ---------
    schema.register('danger', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('dangerTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'danger',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      // allowContentOf: '$block'
      allowContentOf: '$root',
    });

    // --- 危険 ここまで ---------

    // --- 注意 ここから ---------
    schema.register('caution', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('cautionTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'caution',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      // allowContentOf: '$block'
      allowContentOf: '$root',
    });
    // --- 注意 ここまで ---------

    // --- 指示事項 ここから ---------
    schema.register('instructions', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('instructionsTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'instructions',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      // allowContentOf: '$block'
      allowContentOf: '$root',
    });

    schema.register('instructionsDescription', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'instructions',

      // Allow content which is allowed in the root (e.g. paragraphs).
      allowContentOf: '$root',
    });

    schema.addChildCheck((context, childDefinition) => {
      if (context.endsWith('instructionsDescription') && childDefinition.name == 'instructions') {
        return false;
      }
    });
    // --- 指示事項 ここまで ---------

    // // --- 全コラムイラスト ---------
    // schema.register( 'allColumn', {
    //     // Behaves like a self-contained object (e.g. an image).
    //     isObject: true,

    //     // Allow in places where other blocks are allowed (e.g. directly in the root).
    //     allowWhere: '$block'
    // } );

    // schema.register( 'allColumnTitle', {
    //     // Cannot be split or left by the caret.
    //     isLimit: true,

    //     allowIn: 'allColumn',

    //     // Allow content which is allowed in blocks (i.e. text with attributes).
    //     // allowContentOf: '$block'
    //     allowContentOf: '$root',
    //     allowAttributes: [ 'class' ],
    // } );
    // // --- 全コラムイラスト ---------

    // --- L2構造 ここから ---------
    schema.register('l2Section', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('l2Text', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'l2Section',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      allowContentOf: '$root',
      allowAttributes: ['class'],
    });
    // --- L2構造 ここまで ---------

    // --- L3構造 ここから ---------
    schema.register('l3Section', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('l3Text', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'l3Section',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      allowContentOf: '$root',
      allowAttributes: ['class'],
    });
    // --- L3構造 ここまで ---------

    // --- L4構造 ここから ---------
    schema.register('l4Section', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('l4Text', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'l4Section',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      allowContentOf: '$root',
      allowAttributes: ['class'],
    });
    // --- L4構造 ここまで ---------

    // --- L5構造 ここから ---------
    schema.register('l5Section', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block',
    });

    schema.register('l5Text', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'l5Section',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      allowContentOf: '$root',
      allowAttributes: ['class'],
    });
    // --- L5構造 ここまで ---------
  }

  _defineConverters() {
    const conversion = this.editor.conversion;

    // // --- aaa ここから ---------
    // // <illustratedWarningBox> converters
    // conversion.for( 'upcast' ).elementToElement( {
    //     model: 'aaa',
    //     view: {
    //         name: 'section',
    //         // classes: 'warning cbox-inner'
    //         classes: ['aaa']
    //     }
    // } );
    // conversion.for( 'dataDowncast' ).elementToElement( {
    //     model: 'aaa',
    //     view: {
    //         name: 'section',
    //         classes: ['aaa']
    //     }
    // } );
    // conversion.for( 'editingDowncast' ).elementToElement( {
    //     model: 'aaa',
    //     view: ( modelElement, { writer: viewWriter } ) => {
    //         // const section = viewWriter.createContainerElement( 'section', { class: 'warning cbox-inner' } );
    //         const section = viewWriter.createContainerElement( 'section', { class: 'aaa' } );

    //         return toWidget( section, viewWriter, { label: 'simple box widget' } );
    //     }
    // } );

    // // <illustratedWarningOrCautionTitle> converters
    // conversion.for( 'upcast' ).elementToElement( {
    //     model: ( viewElement, { writer } ) => {
    //         // console.log('**%s upcast:', lName)
    //         console.log('[bbb] upcast viewElement:', viewElement)
    //         let id, section_id
    //         if (viewElement.getAttribute( 'htmlDivAttributes' )){
    //             console.log('[bbb] upcast htmlDivAttributes')
    //             console.log('[bbb] upcast viewElement.getAttribute.section_id:', viewElement.getAttribute('htmlDivAttributes').section_id)
    //             console.log('[bbb] upcast viewElement.getAttribute.id:', viewElement.getAttribute('htmlDivAttributes').id)
    //             id = viewElement.getAttribute('htmlDivAttributes').id
    //             section_id = viewElement.getAttribute('htmlDivAttributes').section_id
    //             return writer.createElement( 'bbb', { class: 'bbb', htmlDivAttributes: { 'id': id, 'section_id': section_id } }) ;

    //         } else {
    //             console.log('[bbb] upcast attributes')
    //             console.log('[bbb] upcast viewElement.getAttribute.section_id:', viewElement.getAttribute('section_id'))
    //             console.log('[bbb] upcast viewElement.getAttribute.id:', viewElement.getAttribute('id'))
    //             id = viewElement.getAttribute( 'id' )
    //             section_id = viewElement.getAttribute( 'section_id' )
    //             return writer.createElement( 'bbb', { class: 'bbb', 'id': id, 'section_id': section_id }) ;

    //         }

    //         // return writer.createElement( 'l3Text', { class: 'l3', section_id: viewElement.getAttribute('section_id') } );
    //     },
    //     view: {
    //         name: 'div',
    //         classes: 'bbb'
    //     }
    // } );
    // conversion.for( 'dataDowncast' ).elementToElement( {
    //     model: 'bbb',
    //     // view: {
    //     //     name: 'div',
    //     //     classes: 'bbb'
    //     // }
    //     view: ( modelElement, { writer } ) => {
    //         // console.log('**%s dataDowncast:', lName)
    //         console.log('[bbb] dataDowncast modelElement:', modelElement)

    //         let id, section_id
    //         if (modelElement.getAttribute( 'htmlDivAttributes' )){
    //             console.log('[bbb] dataDowncast htmlDivAttributes')
    //             console.log('[bbb] dataDowncast modelElement.getAttribute.section_id:', modelElement.getAttribute('htmlDivAttributes').attributes.section_id)
    //             console.log('[bbb] dataDowncast modelElement.getAttribute.id:', modelElement.getAttribute('htmlDivAttributes').attributes.id)
    //             id = modelElement.getAttribute('htmlDivAttributes').id
    //             section_id = modelElement.getAttribute('htmlDivAttributes').section_id
    //             return writer.createContainerElement( 'div', { class: 'bbb', htmlDivAttributes: {'id': id, 'section_id': section_id  }} );

    //         } else {
    //             console.log('[bbb] dataDowncast attributes')
    //             console.log('[bbb] dataDowncast modelElement.getAttribute.section_id:', modelElement.getAttribute('section_id'))
    //             console.log('[bbb] dataDowncast modelElement.getAttribute.id:', modelElement.getAttribute('id'))
    //             id = modelElement.getAttribute( 'id' )
    //             section_id = modelElement.getAttribute( 'section_id' )
    //             return writer.createContainerElement( 'div', { class: 'bbb', 'id': id, 'section_id': section_id  } );

    //         }

    //     }

    // } );
    // conversion.for( 'editingDowncast' ).elementToElement( {
    //     model: 'bbb',
    //     view: ( modelElement, { writer: viewWriter } ) => {
    //         // console.log('**%s editingDowncast:', lName)
    //         console.log('[bbb] editingDowncast modelElement:', modelElement)

    //         let div, id, section_id
    //         if (modelElement.getAttribute( 'htmlDivAttributes' )){
    //             console.log('[bbb] editingDowncast htmlDivAttributes')
    //             console.log('[bbb] editingDowncast modelElement.getAttribute.section_id:', modelElement.getAttribute('htmlDivAttributes').attributes.section_id)
    //             console.log('[bbb] editingDowncast modelElement.getAttribute.id:', modelElement.getAttribute('htmlDivAttributes').attributes.id)
    //             id = modelElement.getAttribute('htmlDivAttributes').id
    //             section_id = modelElement.getAttribute('htmlDivAttributes').section_id
    //             // return writer.createContainerElement( 'div', { class: 'bbb', htmlDivAttributes: {'id': id, 'section_id': section_id  }} );
    //             div = viewWriter.createContainerElement( 'div', { class: 'bbb', htmlDivAttributes: {'id': id, 'section_id': section_id  } } );

    //         } else {
    //             console.log('[bbb] editingDowncast attributes')
    //             console.log('[bbb] editingDowncast modelElement.getAttribute.section_id:', modelElement.getAttribute('section_id'))
    //             console.log('[bbb] editingDowncast modelElement.getAttribute.id:', modelElement.getAttribute('id'))
    //             id = modelElement.getAttribute( 'id' )
    //             section_id = modelElement.getAttribute( 'section_id' )
    //             div = viewWriter.createContainerElement( 'div', { class: 'bbb', 'id': id, 'section_id': section_id  } );

    //         }
    //         return toWidgetEditable( div, viewWriter, { label: 'simple box widget' } );

    //     }

    // } );
    // // --- aaa ここまで ---------

    // --- イラスト有り危険 ここから ---------
    // <illustratedDangerBox> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedDanger',
      view: {
        name: 'section',
        // classes: 'danger cbox-inner'
        classes: ['danger', 'cbox-inner'],
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedDanger',
      view: {
        name: 'section',
        classes: ['danger', 'cbox-inner'],
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedDanger',
      view: (modelElement, { writer: viewWriter }) => {
        // const section = viewWriter.createContainerElement( 'section', { class: 'danger cbox-inner' } );
        const section = viewWriter.createContainerElement('section', { class: 'danger cbox-inner' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <illustratedDangerOrCautionTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedDangerTitle',
      view: {
        name: 'div',
        classes: 'left-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedDangerTitle',
      view: {
        name: 'div',
        classes: 'left-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedDangerTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'left-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });

    // <illustratedDangerOrCautionDescription> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedDangerDescription',
      view: {
        name: 'div',
        classes: 'right-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedDangerDescription',
      view: {
        name: 'div',
        classes: 'right-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedDangerDescription',
      view: (modelElement, { writer: viewWriter }) => {
        const div = viewWriter.createEditableElement('div', { class: 'right-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });
    // --- イラスト有り危険 ここまで ---------

    // --- イラスト有り警告 ここから ---------
    // <illustratedWarningBox> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedWarning',
      view: {
        name: 'section',
        // classes: 'warning cbox-inner'
        classes: ['warning', 'cbox-inner'],
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedWarning',
      view: {
        name: 'section',
        classes: ['warning', 'cbox-inner'],
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedWarning',
      view: (modelElement, { writer: viewWriter }) => {
        // const section = viewWriter.createContainerElement( 'section', { class: 'warning cbox-inner' } );
        const section = viewWriter.createContainerElement('section', { class: 'warning cbox-inner' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <illustratedWarningOrCautionTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedWarningTitle',
      view: {
        name: 'div',
        classes: 'left-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedWarningTitle',
      view: {
        name: 'div',
        classes: 'left-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedWarningTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'left-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });

    // <illustratedWarningOrCautionDescription> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedWarningDescription',
      view: {
        name: 'div',
        classes: 'right-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedWarningDescription',
      view: {
        name: 'div',
        classes: 'right-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedWarningDescription',
      view: (modelElement, { writer: viewWriter }) => {
        const div = viewWriter.createEditableElement('div', { class: 'right-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });
    // --- イラスト有り警告 ここまで ---------

    // --- イラスト有り注意 ここから ---------
    // <illustratedWarningOrCautionBox> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedCaution',
      view: {
        name: 'section',
        classes: ['caution', 'cbox-inner'],
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedCaution',
      view: {
        name: 'section',
        classes: ['caution', 'cbox-inner'],
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedCaution',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'caution cbox-inner' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <illustratedWarningOrCautionTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedCautionTitle',
      view: {
        name: 'div',
        classes: 'left-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedCautionTitle',
      view: {
        name: 'div',
        classes: 'left-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedCautionTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'left-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });

    // <illustratedWarningOrCautionDescription> converters
    conversion.for('upcast').elementToElement({
      model: 'illustratedCautionDescription',
      view: {
        name: 'div',
        classes: 'right-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustratedCautionDescription',
      view: {
        name: 'div',
        classes: 'right-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustratedCautionDescription',
      view: (modelElement, { writer: viewWriter }) => {
        const div = viewWriter.createEditableElement('div', { class: 'right-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });
    // --- イラスト有り注意 ここまで ---------

    // --- イラスト有り本文 ここから ---------
    // <illustedTextBox> converters
    conversion.for('upcast').elementToElement({
      model: 'illustedText',
      view: {
        name: 'section',
        classes: 'cbox-inner',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustedText',
      view: {
        name: 'section',
        classes: 'cbox-inner',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustedText',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'cbox-inner' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <illustedTextTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'illustedTextTitle',
      view: {
        name: 'div',
        classes: 'left-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustedTextTitle',
      view: {
        name: 'div',
        classes: 'left-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustedTextTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'left-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });

    // <illustedTextDescription> converters
    conversion.for('upcast').elementToElement({
      model: 'illustedTextDescription',
      view: {
        name: 'div',
        classes: 'right-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'illustedTextDescription',
      view: {
        name: 'div',
        classes: 'right-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'illustedTextDescription',
      view: (modelElement, { writer: viewWriter }) => {
        const div = viewWriter.createEditableElement('div', { class: 'right-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });
    // --- イラスト有り本文 ここまで ---------

    // --- 警告 ここから ---------
    // <warningBox> converters
    conversion.for('upcast').elementToElement({
      model: 'warning',
      view: {
        name: 'section',
        classes: 'warning',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'warning',
      view: {
        name: 'section',
        classes: 'warning',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'warning',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'warning' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <warningTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'warningTitle',
      view: {
        name: 'div',
        classes: 'one-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'warningTitle',
      view: {
        name: 'div',
        classes: 'one-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'warningTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'one-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });
    // --- 警告 ここまで ---------

    // --- 危険 ここから ---------
    // <warningBox> converters
    conversion.for('upcast').elementToElement({
      model: 'danger',
      view: {
        name: 'section',
        classes: 'danger',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'danger',
      view: {
        name: 'section',
        classes: 'danger',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'danger',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'danger' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <dangerTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'dangerTitle',
      view: {
        name: 'div',
        classes: 'one-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'dangerTitle',
      view: {
        name: 'div',
        classes: 'one-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'dangerTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'one-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });
    // --- 危険 ここまで ---------

    // --- 注意 ここから ---------
    // <warningBox> converters
    conversion.for('upcast').elementToElement({
      model: 'caution',
      view: {
        name: 'section',
        classes: 'caution',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'caution',
      view: {
        name: 'section',
        classes: 'caution',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'caution',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'caution' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <warningTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'cautionTitle',
      view: {
        name: 'div',
        classes: 'one-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'cautionTitle',
      view: {
        name: 'div',
        classes: 'one-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'cautionTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'one-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });
    // --- 注意 ここまで ---------

    // --- 指示事項 ここから ---------
    // <instructionsBox> converters
    conversion.for('upcast').elementToElement({
      model: 'instructions',
      view: {
        name: 'section',
        classes: 'supplement',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'instructions',
      view: {
        name: 'section',
        classes: 'supplement',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'instructions',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'supplement' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <instructionsTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'instructionsTitle',
      view: {
        name: 'div',
        classes: 'one-wrap',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'instructionsTitle',
      view: {
        name: 'div',
        classes: 'one-wrap',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'instructionsTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'one-wrap' });

        return toWidgetEditable(div, viewWriter);
      },
    });

    // --- 指示事項 ここまで ---------

    // // --- 全コラムイラスト ここから ---------
    // // <warningBox> converters
    // conversion.for( 'upcast' ).elementToElement( {
    //     model: 'allColumn',
    //     view: {
    //         name: 'section',
    //         classes: 'fullcolumn'
    //     }
    // } );
    // conversion.for( 'dataDowncast' ).elementToElement( {
    //     model: 'allColumn',
    //     view: {
    //         name: 'section',
    //         classes: 'fullcolumn'
    //     }
    // } );
    // conversion.for( 'editingDowncast' ).elementToElement( {
    //     model: 'allColumn',
    //     view: ( modelElement, { writer: viewWriter } ) => {
    //         const section = viewWriter.createContainerElement( 'section', { class: 'fullcolumn' } );

    //         return toWidget( section, viewWriter, { label: 'simple box widget' } );
    //     }
    // } );

    // // <warningTitle> converters
    // conversion.for( 'upcast' ).elementToElement( {
    //     model: 'allColumnTitle',
    //     view: {
    //         name: 'p',
    //         classes: 'fullcolumn'
    //     }
    // } );
    // conversion.for( 'dataDowncast' ).elementToElement( {
    //     model: 'allColumnTitle',
    //     view: {
    //         name: 'p',
    //         classes: 'fullcolumn'
    //     }
    // } );
    // conversion.for( 'editingDowncast' ).elementToElement( {
    //     model: 'allColumnTitle',
    //     view: ( modelElement, { writer: viewWriter } ) => {
    //         // Note: You use a more specialized createEditableElement() method here.
    //         const div = viewWriter.createEditableElement( 'p', { class: 'fullcolumn' } );

    //         return toWidgetEditable( div, viewWriter );
    //     }
    // } );
    // // --- 全コラムイラスト ここまで ---------

    // --- L2構造 ここから ---------
    // <l2Section> converters
    conversion.for('upcast').elementToElement({
      model: 'l2Section',
      view: {
        name: 'section',
        classes: 'l2',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'l2Section',
      view: {
        name: 'section',
        classes: 'l2',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'l2Section',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'l2' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <l2Text> converters
    conversion.for('upcast').elementToElement({
      model: (viewElement, { writer }) => {
        return writer.createElement('l2Text', { class: 'l2' });
      },
      view: {
        name: 'div',
        classes: 'l2',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'l2Text',
      view: (modelElement, { writer }) => {
        return writer.createContainerElement('div', { class: 'l2' });
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'l2Text',
      view: (modelElement, { writer: viewWriter }) => {
        const div = viewWriter.createEditableElement('div', { class: 'l2' });
        return toWidgetEditable(div, viewWriter, { label: 'simple box widget' });
      },
    });
    // --- L2構造 ここまで ---------

    // --- L3構造 ここから ---------
    // <l3Section> converters
    conversion.for('upcast').elementToElement({
      model: 'l3Section',
      view: {
        name: 'section',
        classes: 'l3',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'l3Section',
      view: {
        name: 'section',
        classes: 'l3',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'l3Section',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'l3' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <l3Text> converters
    conversion.for('upcast').elementToElement({
      model: (viewElement, { writer }) => {
        return writer.createElement('l3Text', { class: 'l3' });
      },
      view: {
        name: 'div',
        classes: 'l3',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'l3Text',
      view: (modelElement, { writer }) => {
        return writer.createContainerElement('div', { class: 'l3' });
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'l3Text',
      view: (modelElement, { writer: viewWriter }) => {
        const div = viewWriter.createEditableElement('div', { class: 'l3' });
        return toWidgetEditable(div, viewWriter, { label: 'simple box widget' });
      },
    });
    // --- L3構造 ここまで ---------

    // --- L4構造 ここから ---------
    // <l4Section> converters
    conversion.for('upcast').elementToElement({
      model: 'l4Section',
      view: {
        name: 'section',
        classes: 'l4',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'l4Section',
      view: {
        name: 'section',
        classes: 'l4',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'l4Section',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'l4' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <l4Text> converters
    conversion.for('upcast').elementToElement({
      model: (viewElement, { writer }) => {
        return writer.createElement('l4Text', { class: 'l4' });
      },
      view: {
        name: 'div',
        classes: 'l4',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'l4Text',
      view: (modelElement, { writer }) => {
        return writer.createContainerElement('div', { class: 'l4' });
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'l4Text',
      view: (modelElement, { writer: viewWriter }) => {
        const div = viewWriter.createEditableElement('div', { class: 'l4' });
        return toWidgetEditable(div, viewWriter, { label: 'simple box widget' });
      },
    });
    // --- L4構造 ここまで ---------

    // --- L5構造 ここから ---------
    // <l5Section> converters
    conversion.for('upcast').elementToElement({
      model: 'l5Section',
      view: {
        name: 'section',
        classes: 'l5',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'l5Section',
      view: {
        name: 'section',
        classes: 'l5',
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'l5Section',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'l5' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      },
    });

    // <l5Text> converters
    conversion.for('upcast').elementToElement({
      model: (viewElement, { writer }) => {
        return writer.createElement('l5Text', { class: 'l5' });
      },
      view: {
        name: 'div',
        classes: 'l5',
      },
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'l5Text',
      view: (modelElement, { writer }) => {
        return writer.createContainerElement('div', { class: 'l5' });
      },
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'l5Text',
      view: (modelElement, { writer: viewWriter }) => {
        const div = viewWriter.createEditableElement('div', { class: 'l5' });
        return toWidgetEditable(div, viewWriter, { label: 'simple box widget' });
      },
    });
    // --- L5構造 ここまで ---------
  }
}
